export const clearAllMessage = () => ({
    type: 'CLEAR_ALL_MESSAGE',
})
